export function getEventLabel(start: moment.Moment, end: moment.Moment, dash?: boolean) {
  const isMultiDay = start.get('date') !== end.get('date')
  const isAllDaySingleDay = start.get('hour') === 0 && end.get('hour') === 0 && end.diff(start, 'days') === 1
  const isAllDayMultiDay = isMultiDay && start.get('hour') === 0 && end.get('hour') === 0

  const postfix = dash ? ' - ' : ''
  const delineator = dash ? ' to ' : ' - '

  if (isAllDaySingleDay) {
    return `All Day${postfix}`
  }
  if (isAllDayMultiDay) {
    return `${start.format('MMM D')}${delineator}${end.subtract(1, 'hour').format('MMM D')}${postfix}`
  }
  if (isMultiDay) {
    return `${start.format('MMMM D, h:mma')}${delineator}${end.format('MMMM D, h:mma')}${postfix}`
  }
  // Zero-duration imports (Zapier, GCal) save start === end; Calendar.tsx
  // pads them to a 30-min slot for grid visibility, but labels should show
  // the actual saved time, not the redundant range.
  if (start.isSame(end)) {
    return `${start.format('h:mma')}${postfix}`
  }
  return `${start.format('h:mma')}${delineator}${end.format('h:mma')}${postfix}`
}
